import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import CloseTicketPage from "./features/tickets/CloseTicketPage";
import "./styles/base.css";
import "./styles/auth.css";
import "./styles/layout.css";
import "./styles/components.css";
import "./styles/dialer.css";
import "./styles/followups.css";
import "./styles/reports.css";
import "./styles/agents.css";
import "./styles/settings.css";
import "./styles/lead-journey.css";
import "./styles/filters.css";
import "./styles/dashboard.css";
import "./styles/inventory.css";
import "./styles/reassign.css";

function isCloseTicketRoute() {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  return /^\/tickets\/[^/]+\/?$/.test(path) && params.get("action") === "close";
}

const rootEl = document.getElementById("root");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    {isCloseTicketRoute() ? <CloseTicketPage /> : <App />}
  </React.StrictMode>,
);
